require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-cop-29-fell-short-on-climate-finance-how-can-mdbs-d.json") })
        }
      }, "path---en-us-update-cop-29-fell-short-on-climate-finance-how-can-mdbs-d");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-cop-29-fell-short-on-climate-finance-how-can-mdbs-d!./.cache/json/en-us-update-cop-29-fell-short-on-climate-finance-how-can-mdbs-d.json
// module id = 647
// module chunks = 231608221292675